import config from 'react-global-configuration';
import { isDev } from '@config/index';

export const getBrandBaseUrl = () => {
  const partner = localStorage.getItem('redirected_from_partner');
  const org = config.get('id');
  const platformUrl = config.get('platformUrl');

  if (isDev && org) {
    return `/organizations/${org}`;
  }

  if (partner && platformUrl) {
    return platformUrl.startsWith('http') ? platformUrl : `https://${platformUrl}`;
  }

  return '/';
};

export const updateBrandAssets = (baseUrl) => {
  const cacheBust = `?v=${new Date().getTime()}`;

  const createUrl = (file) => {
    const cleanBase = baseUrl === '/' ? '' : baseUrl;
    return `${cleanBase}/${file}${cacheBust}`;
  };

  document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach(link => {
    const originalHref = link.getAttribute('href');
    const file = originalHref.split('/').pop().split('?')[0];

    if (file) {
      link.href = createUrl(file);
    }
  });

  const apple = document.querySelector('link[rel="apple-touch-icon"]');
  if (apple) {
    apple.href = createUrl('apple-touch-icon.png');
  }

  const manifest = document.querySelector('link[rel="manifest"]');
  const isPartnerInDev = isDev && baseUrl.startsWith('http');

  if (manifest && !isPartnerInDev) {
    manifest.href = createUrl('manifest.json');
  }
};

export const applyBrandFromConfig = () => {
  const baseUrl = getBrandBaseUrl();
  updateBrandAssets(baseUrl);

  const orgId = config.get('id');
  const companyName = config.get('company');

  if (companyName) {
    const titleTag = document.querySelector('title');
    if (titleTag) titleTag.textContent = `${companyName} Platform`;
  }

  const descriptionName = companyName || orgId;
  if (descriptionName) {
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) descriptionMeta.setAttribute('content', `${descriptionName} web application`);
  }
};
